import { memo, useEffect } from 'react'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { ActionHistoryRow } from '../ActionHistoryRow/ActionHistoryRow'
import styles from './ActionsHistry.module.scss'
import { selectActionsHistoryByGuid } from '../../../store/selectors/actionsSelectors/actionsHistorySelectors'
import { fetchProductActionsHistory } from '../../../store/async-thunks/actions/fetchProductActionsHistory'

interface ActionsHistoryProps {
    guid: string
}

export const ActionsHistory = memo(function ActionsHistory(
    props: ActionsHistoryProps
) {
    const { guid } = props
    const dispatch = useAppDispatch()

    const actionsHistoryItems = useAppSelector(
        selectActionsHistoryByGuid(guid)
    )

    useEffect(() => {
        dispatch(fetchProductActionsHistory({ guid }))
    }, [dispatch, guid])

    return (
        <div>
            <h5>Actions board</h5>
            {!!actionsHistoryItems?.length ? (
                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th className={styles.tableHead}>PRODUCT TIME</th>
                            <th className={styles.tableHead}>ACTION</th>
                            <th className={styles.tableHead}>STATUS</th>
                            <th className={styles.tableHead}>RESULT</th>
                            <th className={styles.tableHead}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {actionsHistoryItems.map((actionHistory) => (
                            <ActionHistoryRow
                                key={actionHistory.action_id}
                                actionHistoryItem={actionHistory}
                            />
                        ))}
                    </tbody>
                </table>
            ) : (
                <div className={`${styles.noData} m-auto`}>No data</div>
            )}
        </div>
    )
})
